import React from 'react';

import { Wrapper } from './Block.jsx';
import { EmptyPlaceholder } from '../utility/blocks';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

import { default as ClickToken } from '../../../../../artcloud.click/source/scripts/common/Token.jsx';

// #region COMPONENTS

function InventoryMetaComponent(props) {
    const _data = (props) => {
        let data = props.data || {};
        if (data.Inventory) {
            data = data.Inventory;
            if (Array.isArray(data) && data.length > 0) {
                data = data[0];
            }
        }
        return data;
    }
    const parseContent = (props, tokenizedString) => {
        if (!tokenizedString) {
            return '';
        }
        // const data = props.data || {};
        const data = _data(props);
        return ClickToken.parseTokenizedString(tokenizedString, (keyword, options) => {
            let replaceString = '';
            switch (keyword) {
                case Token.Inventory.Artist:
                    if (data.Artist && data.Artist.Name && data.Artist.Name.length > 0) {
                        replaceString = `<span class='artwork__info__item__dimensions'>${ClickToken.getReplacementString(data.Artist.Name, options)}</span>`;
                    }
                    break;
                case Token.Inventory.Date:
                    if (data.Date && data.Date.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.Date, options);
                    }
                    break;
                case Token.Inventory.Dimensions:
                    if (data.Dimensions && data.Dimensions.length > 0) {
                        replaceString = `<span class='artwork__info__item__dimensions'>${ClickToken.getReplacementString(data.Dimensions, options)}</span>`;
                    }
                    break;
                case Token.Inventory.Edition:
                    if (data.Edition && data.Edition.length > 0) {
                        replaceString = `<span class='artwork__info__item__edition'>${ClickToken.getReplacementString(data.Edition, options)}</span>`;
                    }
                    break;
                case Token.Inventory.Medium:
                    if (data.Medium && data.Medium.length > 0) {
                        replaceString = `<span class='artwork__info__item__medium'>${ClickToken.getReplacementString(data.Medium, options)}</span>`;
                    }
                    break;
                case Token.Inventory.Number:
                    if (data.Number && data.Number.length > 0) {
                        replaceString = `<span class='artwork__info__item__number'>${ClickToken.getReplacementString(data.Number, options)}</span>`;
                    }
                    break;
                case Token.Inventory.Price:
                    if (data.Price && data.Price.length > 0) {
                        replaceString = `<span class='artwork__info__item__price'>${ClickToken.getReplacementString(data.Price, options)}</span>`;
                    }
                    break;
                case Token.Inventory.SKU:
                    if (data.SKU && data.SKU.length > 0) {
                        replaceString = `<span class='artwork__info__item__sku'>${ClickToken.getReplacementString(data.SKU, options)}</span>`;
                    }
                    break;
                case Token.Inventory.Title:
                    if (data.Title && data.Title.length > 0) {
                        replaceString = `<span class='artwork__title notranslate'>${ClickToken.getReplacementString(data.Title, options)}</span>`;
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            if (replaceString == '' && options && options.default && options.default.length > 0) {
                replaceString = options.default;
                if (replaceString.trim().length == 0) {
                    replaceString = '&nbsp;'
                }
            }
            return replaceString;
        });
    }
    const data = _data(props);
    const design = props.blockConfig && props.blockConfig.block && props.blockConfig.block.design;
    const [content, setContent] = React.useState(undefined);
    React.useEffect(() => {
        setContent(parseContent(props, props.blockConfig.block.design));
    }, [data.EditionId, design]);

    if (props.serverSide && content == undefined) {
        setContent(parseContent(props, props.blockConfig.block.design));
    }
    if (!props.builder && content != undefined && content.length == 0) {
        return null;
    }
    let Component = InventoryMetaBlockComponent;
    if (props.inCell) {
        Component = InventoryMetaCellComponent;
    }
    return <Component {...props} content={content} />
}

function InventoryMetaBlockComponent(props) {
    const { contentContainerStyle, contentStyle, innerStyle, wrapperStyle } = Utilities.parseTextWrapperConfig(props.blockConfig);
    return (
        <Wrapper {...props} className="SharedCaptionBlock" style={wrapperStyle}>
            <td align="center" className="SharedCaptionBlockInner" style={innerStyle} valign="top">
                <table
                    align="center"
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    className="SharedCaptionBottomContent"
                    style={contentContainerStyle}
                    width={props.maxWidth}>
                    <tbody>
                        <tr>
                            <td
                                className="SharedTextContent"
                                style={contentStyle}
                                valign="middle">
                                {
                                    props.content != undefined &&
                                    <div dangerouslySetInnerHTML={{ __html: props.content }} style={{ lineHeight: 1 }} />
                                }
                                {
                                    props.builder &&
                                    (props.content == undefined || props.content.length == 0) &&
                                    <EmptyPlaceholder fullWidth={true} />
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </Wrapper>
    );
}

function InventoryMetaCellComponent(props) {
    const containerInsideStyle = { minWidth: props.maxWidth };
    const containerOutsideStyle = {};
    const contentStyle = { lineHeight: 1 };
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            Utilities.mapStyleConfigProps(contentStyle, props.blockConfig.block, (propName, propValue) => {
                switch (propName) {
                    case 'backgroundColor':
                        containerInsideStyle.backgroundColor = propValue;
                        return true;
                    case 'design':
                        return true;
                }
            });
        }
        if (props.blockConfig.layout) {
            Utilities.mapStyleConfigProps(contentStyle, props.blockConfig.layout);
        }
    }
    return (
        <table
            align="center"
            border="0"
            cellPadding="0"
            cellSpacing="0"
            className="SharedCaptionBlock"
            width={props.maxWidth}>
            <tbody className="SharedCaptionBlockOuter">
                <tr>
                    <td
                        align="center"
                        className="SharedCaptionBlockInner"
                        style={containerOutsideStyle}
                        valign="top">
                        <table
                            align="center"
                            border="0"
                            cellPadding="0"
                            cellSpacing="0"
                            className="SharedCaptionBottomContent"
                            style={containerInsideStyle}
                            width={props.maxWidth}>
                            <tbody style={{ backgroundColor: containerInsideStyle.backgroundColor }}>
                                <tr>
                                    <td
                                        className="SharedTextContent"
                                        style={{ backgroundColor: containerInsideStyle.backgroundColor, fontFamily: TypeConfig.defaultFontFamily, wordBreak: 'break-word' }}
                                        valign="middle">
                                        {
                                            props.content != undefined &&
                                            <div dangerouslySetInnerHTML={{ __html: props.content }} style={contentStyle} />
                                        }
                                        {
                                            props.builder &&
                                            (props.content == undefined || props.content.length == 0) &&
                                            <div style={contentStyle}>
                                                <EmptyPlaceholder fullWidth={true} />
                                            </div>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

// #endregion COMPONENTS

const InventoryMetaTokens = (context) => {
    const isCampaign = context == Name.Content.EmailBody;
    let tokens = [
        Token.getWrappedTokenConfig('Artist', Token.Inventory.Artist, isCampaign),
        Token.getWrappedTokenConfig('Title', Token.Inventory.Title, isCampaign),
        Token.getWrappedTokenConfig('Created Date', Token.Inventory.Date, isCampaign),
        Token.getWrappedTokenConfig('Medium', Token.Inventory.Medium, isCampaign),
        Token.getWrappedTokenConfig('Dimensions', Token.Inventory.Dimensions, isCampaign),
        Token.getWrappedTokenConfig('Price', Token.Inventory.Price, isCampaign)
    ];
    if (isCampaign) {
        tokens.splice(2, 0, Token.getWrappedTokenConfig('Edition Info', Token.Inventory.Edition));
    } else {
        // Number and SKU are only populated on transactional inventory data, not campaigns
        tokens.splice(5, 0,
            Token.getWrappedTokenConfig('Inventory Number', Token.Inventory.Number, isCampaign),
            Token.getWrappedTokenConfig('SKU', Token.Inventory.SKU, isCampaign)
        );
    }
    return tokens;
}
const InventoryMetaTypeConfig = {
    defaultDesign: (type) => {
        let defaultValue = '';
        if (type == Name.Content.EmailBody) {
            defaultValue = ' ';
        }
        return `<p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Inventory.Artist}">{${Token.Inventory.Artist}("before":"","after":"","default":"${defaultValue}")}</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="display:inline;font-family:${TypeConfig.defaultFontFamily};font-size:16px;font-style:italic;line-height:24px;vertical-align:middle;" token="${Token.Inventory.Title}">{${Token.Inventory.Title}("before":"","after":"","default":"")}</span><span style="display:inline;font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Inventory.Edition}">{${Token.Inventory.Edition}("before":" (","after":")","default":"")}</span><span style="display:inline;font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Inventory.Date}">{${Token.Inventory.Date}("before":", ","after":"","default":"")}</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Inventory.Medium}">{${Token.Inventory.Medium}("before":"","after":"","default":"${defaultValue}")}</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Inventory.Dimensions}">{${Token.Inventory.Dimensions}("before":"","after":"","default":"${defaultValue}")}</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Inventory.Price}">{${Token.Inventory.Price}("before":"","after":"","default":"${defaultValue}")}</span></p>`
    },
    panel: {
        block: function ({ type = Name.Content.EmailBody } = {}) {
            const group = 'block';
            const blockConfig = {
                group,
                label: 'Content',
                options: [
                    {
                        display: 'Design inventory meta here',
                        group,
                        name: 'design',
                        type: 'rich-text-campaign-short',
                        value: InventoryMetaTypeConfig.defaultDesign(type)
                    },
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color'
                    }
                ]
            };
            if (type != Name.Content.EmailBody) {
                blockConfig.options.push({
                    display: 'Content Background Color',
                    group,
                    name: 'contentColor',
                    type: 'color'
                });
            }
            blockConfig.options.push(
                {
                    display: 'Border Radius',
                    group,
                    name: 'borderRadius',
                    options: TypeConfig.options.measurement(),
                    type: 'measurement'
                },
                {
                    display: 'Border',
                    group,
                    name: 'border',
                    options: TypeConfig.options.measurement(),
                    type: 'border'
                }
            );
            return blockConfig;
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        disabled: ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'],
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '9', unit: 'px' },
                            paddingTop: { value: '9', unit: 'px' }
                        }
                    }
                ]
            };
        }
    }
}
const InventoryMetaBlockTypeDefinition = (group, options) => {
    return {
        id: Name.Block.Inventory.Text,
        config: {
            block: InventoryMetaTypeConfig.panel.block(options),
            layout: InventoryMetaTypeConfig.panel.layout()
        },
        display: 'Inventory Meta Text',
        group,
        image: 'inventory_meta_text.png'
    };
}
export { InventoryMetaBlockTypeDefinition, InventoryMetaComponent, InventoryMetaTokens, InventoryMetaTypeConfig }